import { VueExtension } from '../../utils/extensions/vue'
import Sticky from './sticky.jsx'
import './sticky.scss'

VueExtension.WithInstall(Sticky)

export default Sticky